import { render, staticRenderFns } from "./TitleWithPenSwitcher.vue?vue&type=template&id=18f99b50&scoped=true&lang=pug&"
import script from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
export * from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithPenSwitcher.vue?vue&type=style&index=0&id=18f99b50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f99b50",
  null
  
)

export default component.exports